import { combineReducers } from "redux";
import { authReducer, forgotReducer, storePermissionReducer } from "./authentication/reducers";
import ChangeLayoutMode from "./themeLayout/reducers";
import { dashboardRecentActivityReducer, storeDashboardDataReducers } from "./dashboard/reducers";
import { historyListReducer } from "./history/reducers";
import {
  apexTradeModelListReducer,
  exchangeModelDetailReducer,
  getBrandReducers,
  getEmployeeDetailReducers,
  getModelReducers,
  productTypeReducers,
  tradeModelListReducer,
} from "./common/reducers";

const rootReducers = combineReducers({
  // Base Reducers
  auth: authReducer,
  forgot: forgotReducer,
  ChangeLayoutMode,
  storeDashboardData: storeDashboardDataReducers,
  dashboardRecentActivity: dashboardRecentActivityReducer,
  historyList: historyListReducer,
  storePermission: storePermissionReducer,

  // Common Reducers
  productType: productTypeReducers,
  getModel: getModelReducers,
  getBrand: getBrandReducers,
  getEmployeeDetail: getEmployeeDetailReducers,
  exchangeModelDetail: exchangeModelDetailReducer,
  apexTradeModelListData: apexTradeModelListReducer,
  tradeModelListData: tradeModelListReducer,
});

export default rootReducers;
